import { ValueOf } from '../../types/util.types'

export type FontWeightProperty =
    | 'normal'
    | 'bold'
    | 'bolder'
    | 'lighter'
    | number
    | 'initial'
    | 'inherit'

export type IBcPeriodToggleButton = {
    label: string
    key: string
    selected: boolean
}

export interface IBcSelectButton {
    label?: string
    selected: boolean
    circleColor?: string
}

export const XButtonTypes = {
  GLASS: 'glass',
  LINE: 'line',
  SOLID: 'solid',
} as const

export type XButtonTypesType = ValueOf<typeof XButtonTypes>

export type BcButtonProps = {
  type?: XButtonTypesType
  icon?: string
  leftIcon?: string
  rightIcon?: string
  upText?: string
  downText?: string
  color?: string
  backgroundColor?: string
  disabled?: boolean
  submit?: boolean
  loading?: boolean
  dropdownBtn?: boolean
  svg? : boolean
  gaEventName?: string
}

export type XButtonProps = {
  variant?: XButtonTypesType
  color?: string
  backgroundColor?: string
  disabled?: boolean
  loading?: boolean
  padding?: string | number
  gaEventName?: string
  type?: HTMLButtonElement['type']
}